<div
  #dropdownContainer
  class="custom-dropdown"
  [ngClass]="[extraClasses, dropdownOpen ? 'open' : '', disabled ? 'disabled' : '']"
>
  <div
    class="dropdown-toggle"
    (click)="toggleDropdown()"
    (keydown)="onToggleKeydown($event)"
    [attr.tabindex]="disabled ? -1 : 0"
    role="combobox"
    [attr.aria-expanded]="dropdownOpen"
    aria-haspopup="listbox"
    [attr.aria-label]="placeholder"
    [ngClass]="{ placeholder: value === '' }"
  >
    @if (value === '') {
      <span>{{ placeholder }}</span>
    } @else {
      <div class="selected-region-display">
        <span class="region-name">{{ getSelectedRegionName(value) }}</span>
        <span class="region-slug">{{ value }}</span>
      </div>
    }
    <svg lucideChevronDown class="dropdown-arrow" [ngClass]="{ rotated: dropdownOpen }"></svg>
  </div>
  @if (dropdownOpen) {
    <div class="dropdown-menu">
      <div class="search-container">
        <input
          #searchInput
          type="text"
          class="search-input"
          placeholder="Search regions..."
          [value]="searchTerm"
          (input)="onSearchInput($event)"
          (keydown)="onSearchKeydown($event)"
          autocomplete="off"
        />
        <svg lucideSearch class="search-icon"></svg>
      </div>
      <div class="dropdown-items-container">
        @if (filteredRegions$ | async; as regions) {
          @for (region of regions; track region) {
            <div
              class="dropdown-item"
              (click)="selectRegion(region)"
              [ngClass]="{
                selected: region.value === value,
                disabled: isRegionDisabled(region),
              }"
            >
              <div class="region-display">
                <span class="region-name">{{ getRegionNameOnly(region.label) }}</span>
                <span class="region-slug">{{ region.value }}</span>
              </div>
            </div>
          }
          @if (regions.length === 0 && searchTerm) {
            <div class="no-results">No regions found matching "{{ searchTerm }}"</div>
          }
        } @else {
          <div class="loading-spinner">
            <svg lucideLoaderCircle class="lucide-spin"></svg>
            <span>Loading regions...</span>
          </div>
        }
      </div>
    </div>
  }
</div>
